export default __webpack_public_path__ + "static/media/advanced_robotics.17185ea9.png";